import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-intersection-observer',
	templateUrl:'./WaIntersectionObserverPage.html',
	styles: [],
	styleUrls:['./WaIntersectionObserverPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaIntersectionObserverPage
{
	mdContent_372 = `\`\`\`java
import com.jwebmp.webawesome.components.observer.WaIntersectionObserver;
\`\`\``;
}
